import type { IClient } from "intake_shared/src/types";

export function getFeeRevision(value: unknown): string | undefined {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? undefined : value.toISOString();
    }
    if (typeof value === "string") {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
    }
    if (typeof value !== "object" || value === null) return undefined;
    const timestamp = value as { toDate?: () => Date };
    return typeof timestamp.toDate === "function"
        ? getFeeRevision(timestamp.toDate())
        : undefined;
}

export function hasFeeChanges(
    client: Pick<IClient, "fees_update_details" | "loaded_fee_revision">
): boolean {
    return (
        getFeeRevision(client.fees_update_details?.updated_at) !==
        getFeeRevision(client.loaded_fee_revision)
    );
}
